import React from 'react';

const GateFree = () => {
  const handlePayment = (plan, price) => {
    alert(`[GateFree 결제 시스템]\n선택 상품: ${plan}\n금액: ${price.toLocaleString()}원\n\n안전한 결제창으로 연결합니다.`);
  };

  return (
    <div className="min-h-screen bg-white font-sans text-[#1a1a1a] antialiased">
      {/* 1. 카페24 스타일 슬림 헤더 */}
      <nav className="sticky top-0 z-50 bg-white/70 backdrop-blur-xl border-b border-gray-100 px-6 py-4">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <div className="text-xl font-black tracking-widest text-blue-700">GATEFREE</div>
          <div className="hidden md:flex items-center space-x-12 text-[13px] font-bold tracking-tight text-gray-500">
            <a href="#about" className="hover:text-black transition">BRAND</a>
            <a href="#service" className="hover:text-black transition">SERVICE</a>
            <a href="#pricing" className="hover:text-black transition">MEMBERSHIP</a>
            <a href="#qna" className="hover:text-black transition">Q&A</a>
          </div>
          <div className="flex items-center space-x-4">
            <button className="text-[12px] font-bold border-b border-black pb-0.5">LOGIN</button>
          </div>
        </div>
      </nav>

      {/* 2. 메인 비주얼 (카페24 특유의 미니멀리즘) */}
      <section className="relative px-6 pt-24 pb-20 md:pt-40 md:pb-32 bg-[#f8f9fa]">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-[12px] md:text-[14px] font-bold tracking-[0.2em] text-blue-600 mb-6 uppercase">
            Smart Access Solution
          </h2>
          <h1 className="text-4xl md:text-6xl font-light leading-tight tracking-tight mb-10 text-gray-900">
            일상을 바꾸는 <br />
            <strong>가장 완벽한 통과.</strong>
          </h1>
          <p className="text-[14px] md:text-[16px] text-gray-400 font-light leading-loose max-w-xl mx-auto mb-12">
            멈추지 않는 경험, 게이트프리 솔루션.<br />
            당신의 공간에 어울리는 품격 있는 출입 경험을 선사합니다.
          </p>
          <button className="bg-black text-white px-12 py-5 rounded-none text-[13px] font-bold tracking-widest hover:bg-gray-800 transition-all active:scale-95 shadow-2xl">
            SHOP NOW
          </button>
        </div>
      </section>

      {/* 3. 상품 섹션 (쇼핑몰 요금제 스타일) */}
      <section id="pricing" className="py-24 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-end mb-16 border-b border-gray-900 pb-6">
            <h3 className="text-2xl font-bold tracking-tighter">MEMBERSHIP</h3>
            <span className="text-[12px] text-gray-400 mt-2 md:mt-0 italic">Choose your perfect pass</span>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20">
            {/* 상품 1: 1회권 (카페24 상품 리스트 느낌) */}
            <div className="group cursor-pointer">
              <div className="aspect-[4/5] bg-[#f2f2f2] mb-6 flex items-center justify-center transition-all group-hover:bg-[#e9e9e9] relative overflow-hidden">
                <span className="text-gray-300 font-black text-6xl tracking-tighter group-hover:scale-110 transition-transform duration-500">SINGLE</span>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                   <button onClick={() => handlePayment('1회권', 3300)} className="bg-white px-8 py-3 text-[12px] font-bold border border-black hover:bg-black hover:text-white transition">ADD TO CART</button>
                </div>
              </div>
              <h4 className="text-[15px] font-bold mb-1">게이트프리 싱글 패스 (1일권)</h4>
              <p className="text-[13px] text-gray-400 mb-3">방문객을 위한 원데이 익스프레스 인증 서비스</p>
              <span className="text-[16px] font-bold">₩3,300</span>
            </div>

            {/* 상품 2: 정기권 */}
            <div className="group cursor-pointer">
              <div className="aspect-[4/5] bg-[#1a1a1a] mb-6 flex items-center justify-center transition-all group-hover:bg-[#000] relative overflow-hidden text-white">
                 <span className="text-gray-800 font-black text-6xl tracking-tighter group-hover:scale-110 transition-transform duration-500">MONTH</span>
                 <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                   <button onClick={() => handlePayment('정기권', 29900)} className="bg-white text-black px-8 py-3 text-[12px] font-bold border border-white hover:bg-gray-100 transition">BUY IT NOW</button>
                </div>
              </div>
              <div className="flex items-center space-x-2 mb-1">
                <h4 className="text-[15px] font-bold">게이트프리 프리미엄 정기권</h4>
                <span className="bg-red-500 text-[10px] text-white px-1 font-bold">BEST</span>
              </div>
              <p className="text-[13px] text-gray-400 mb-3">매일의 통과를 더 가볍게, 월간 무제한 패스</p>
              <div className="flex items-center space-x-2">
                <span className="text-[16px] font-bold">₩29,900</span>
                <span className="text-[12px] text-gray-300 line-through">₩35,000</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. 푸터 (깔끔한 쇼핑몰 하단) */}
      <footer className="bg-white py-20 px-6 border-t border-gray-100">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between text-[11px] text-gray-400 leading-relaxed uppercase tracking-widest font-bold">
           <div className="mb-8 md:mb-0">
              <p className="text-black mb-4">CS CENTER 1588-XXXX</p>
              <p>평일 10:00 - 17:00 / 점심 12:00 - 13:00</p>
              <p>주말 및 공휴일 휴무</p>
           </div>
           <div className="grid grid-cols-2 gap-12">
              <div>
                 <p className="text-black mb-4">INFORMATION</p>
                 <p className="mb-2 hover:text-black cursor-pointer">About us</p>
                 <p className="mb-2 hover:text-black cursor-pointer">Agreement</p>
                 <p className="mb-2 hover:text-black cursor-pointer">Privacy Policy</p>
              </div>
              <div>
                 <p className="text-black mb-4">COMPANY</p>
                 <p className="mb-1 text-[10px] normal-case font-medium">상호 : (주)게이트프리 | 대표 : OOO | 사업자 : 000-00-00000</p>
                 <p className="mb-1 text-[10px] normal-case font-medium">주소 : 서울특별시 어딘가 게이트프리 타워 101호</p>
              </div>
           </div>
        </div>
      </footer>
    </div>
  );
};

export default GateFree;